import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { isTrue } from '../../../utils/booleanUtil';

import MenuItem from './MenuItem';

function Menu({ canSearchTicket }) {
  function getBasicItems() {
    return [{
      index: 0,
      name: 'Ponto de atendimento',
      path: '/workstation',
      icon: 'desktop',
      visible: true,
    }];
  }

  function getAttendanceItems() {
    return [{
      index: 1,
      name: 'Atendimento',
      path: '/attendance',
      icon: 'user',
      visible: true,
    }, {
      index: 2,
      name: 'Pesquisar senhas',
      path: '/search',
      icon: 'receipt',
      visible: isTrue(canSearchTicket),
    }, {
      index: 3,
      name: 'Agendamento',
      path: loggedUser.company.schedulingUrl,
      icon: 'calendar-alt',
      visible: isTrue(loggedUser.company.hasScheduling),
      externalLink: true,
    }];
  }

  const loggedUser = useSelector((state) => state.user.data);
  const [items, setItems] = useState(getBasicItems());

  useEffect(() => {
    if (loggedUser.loggedOnWorkstation) {
      setItems(getAttendanceItems());
    } else {
      setItems(getBasicItems());
    }
  }, [loggedUser.loggedOnWorkstation]);

  return (
    <ul className="list-unstyled components">
      { items.filter((item) => item.visible).map((item) =>
        <MenuItem key={item.index} {...item} />)}
    </ul>
  );
}

Menu.propTypes = {
  canSearchTicket: PropTypes.string,
};

Menu.defaultProps = {
  canSearchTicket: 'F',
};

export default Menu;
